import { Brand, Phone } from './index';

export class Variant {
  id: string;
  name: string;
  nameId: string;
  brand: Brand;
  phone: Phone;
  currentPrice: number;
  prices: Array<{price}>;

  constructor({brand, phone, id, name = '', nameId = '', prices, currentPrice}) {
    this.id = id;
    this.brand = brand;
    this.phone = phone;
    this.name = name;
    this.nameId = nameId;
    this.prices = prices;
    this.currentPrice = currentPrice;
  }

  get fullName() {
    return `${this.phone.name}${(this.name) ? ' ' + this.name : ''}`;
  }

  getSuggestedVariants(): Variant[] {
    const variantList: Variant[] = [];
    // Return a better variant, same phone
    if (this.phone.variants.size > 1) {
      this.phone.variants.forEach((variant) => {
        // console.log(variant);
        if (variant.prices[0] > this.prices[0]) {
          variantList.push(variant);
        }
      });
    }
    // TODO:
    // Return n variant any phone !== current phone

    return variantList;
  }

  getShopUrl(website: string): string {
    let url = '';
    const variantUrl = `${this.brand.id} ${this.phone.id} ${(this.nameId) ? ` ${this.nameId}` : ''}`.replace(/ |-/g, '+');
    if (website === 'kijiji') {
      url = `http://www.kijiji.it/elettronica/cellulari-e-accessori/${variantUrl}`;
    } else if (website === 'subito') {
      url = `http://www.subito.it/annunci-italia/vendita/telefonia/?q=${variantUrl}`;
    }
    console.log(url);
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/models/variant.ts